import { Button } from '@/view/components/ui/button'
import { CircleMinus } from 'lucide-react'
import clsx from 'clsx'
import { useConsultSettingsController } from './useConsultSettingsController'
import { Skeleton } from '@/view/components/ui/skeleton'

export function ConsultSettings() {
  const { data, isLoading, handleDeleteAllConsults, buttons } =
    useConsultSettingsController()

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <Skeleton className="h-6 w-1/3" />
        <div className="flex gap-2">
          <Skeleton className="h-[84px] w-[49%]" />
          <Skeleton className="h-[84px] w-[49%]" />
        </div>
        <Skeleton className="h-[48px] w-full" />
        <Skeleton className="h-[1px] w-full" />
        <div className="flex justify-between">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-6 w-20" />
        </div>
      </div>
    )
  }

  return (
    <div className="flex grow flex-col gap-5">
      <h2 className="font-semibold">Configurações</h2>
      <div className="flex items-center justify-center gap-2">
        {buttons.map(({ isSelect, label, sublabel, onClick }) => (
          <Button
            key={`${label}-${sublabel}`}
            onClick={onClick}
            className={clsx(
              'flex h-[84px] w-[49%] flex-col text-white',
              !isSelect &&
                'border border-gray01 bg-white02 text-black hover:bg-gray-200',
            )}
          >
            <p>{label}</p>
            <p
              className={clsx(
                'text-xs ',
                isSelect ? 'text-white' : 'text-black04',
              )}
            >
              {sublabel}
            </p>
          </Button>
        ))}
      </div>
      <Button
        onClick={handleDeleteAllConsults}
        className="w-full border border-rose-300 bg-rose-100 text-rose-400 hover:bg-rose-200"
      >
        <div className="flex items-center justify-center gap-2">
          <CircleMinus />
          Zerar fila de consultas
        </div>
      </Button>
      <div className="h-[1px] w-full bg-gray01" />
      <div className="flex items-center justify-between">
        <div>
          <p className="text-[12px] text-black04">Agendados</p>
          <p className="text-[12px] font-bold">
            {data?.schedule.toLocaleString()}
          </p>
        </div>
        <div className="flex flex-col items-center justify-center">
          <p className="text-[12px] text-black04">Com saldo</p>
          <p className="text-[12px] font-bold">
            {data?.hasAmount.toLocaleString()}
          </p>
        </div>
        <div className="flex flex-col items-end">
          <p className="text-[12px] text-black04">Não Autorizados</p>
          <p className="text-[12px] font-bold">
            {data?.unauthorized.toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  )
}
